import React from 'react';
import { Text, localizationMaps } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

// For fixing items that don't camel case well in the database.
const map = {
    'ippBreathingMachine': 'IPP Breathing Machine'
};

/*
 * Items that should not display under reasonable and customary header
 * Surgical Bra is grouped under prosthetics
 */
const excludedCoverageItems = [ 'surgicalBra' ];

const styles = {
    row: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 5,
        marginBottom: 10
    }
};

/**
 *
 * @param {*} param0
 */
const CoverageBlockMedicalNoMax = ({ coverage }) => Object.keys(coverage).map((item) => {
    // Make sure there is a value associated with each row that isn't 0
    if (coverage[item] === 'rc' && !excludedCoverageItems.includes(item) && !(item === 'hospitalBenefits' && coverage.privateHospital === 2)) {
        return (
            <div key={item} style={styles.row}>
                <Text small customStyle={{ flex: 1 }}>
                    {map[item] ? localizationMaps.fromEnglish("benefits", map[item]) : localizationMaps.fromEnglish("benefits", helpers.camelToNormalCase(item))}
                </Text>
            </div>
        );
    }

    return true;
});


export default (CoverageBlockMedicalNoMax);